import * as React from 'react';
import { callAll, noop } from '../../util/fn-util';
import { is } from '../../util/is';
import { getClassName } from '../../util/string-util';
import { FieldContextConsumer, IFieldContext } from './Field';
import './Input.scss';

class InputContainer extends React.Component<IProps & { contextVal: IFieldContext }> {
  render() {
    const {
      className,
      onFocus,
      onBlur,
      onChange,
      onChangeValue,
      id,
      contextVal,
      ...props
    } = this.props;

    return (
      <input
        className={getClassName(
          'input',
          className,
          contextVal.isFilled && 'is-filled',
          contextVal.isFocused && 'is-focused'
        )}
        onFocus={callAll(onFocus, contextVal.handleSetIsFocused(true))}
        onBlur={callAll(onBlur, contextVal.handleSetIsFocused(false))}
        onChange={callAll(onChange, this.handleChange)}
        id={id || contextVal.fieldId}
        {...props}
      />
    );
  }

  handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.value;

    if (typeof this.props.onChangeValue === 'function') {
      this.props.onChangeValue(value);
    }

    this.props.contextVal.handleSetIsFilled(is.FilledText(value))();
  };

  componentDidMount() {
    if (is.FilledText(this.props.value)) {
      this.props.contextVal.handleSetIsFilled(true)();
    }
  }

  static defaultProps: Partial<IProps> = {
    onChangeValue: noop
  };
}

interface IProps
  extends React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  onChangeValue?: (value: string) => void;
}

export const Input = ({ ref, ...props }: IProps) => (
  <FieldContextConsumer>
    {contextVal => <InputContainer contextVal={contextVal} {...props} />}
  </FieldContextConsumer>
);



// WEBPACK FOOTER //
// ./src/components/Control/Input.tsx